import React from "react"
import PropTypes from "prop-types"
import Downshift from "downshift"
import styled from "styled-components"
import matchSorter from "match-sorter"
import { Scrollbars } from "react-custom-scrollbars"
import PersonCardShape from "../../state/shapes/PersonCardShape"
import { PersonCard } from "../widgets"
import { CloseIcon } from "../themed-html-components"

const Div = styled.div`
  position: relative;
`

const Input = styled.input`
  width: 100%;

  line-height: 1em;

  min-height: 2em;
  background: #fff;
  display: inline-block;
  padding: 7px;

  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 0.3rem;
`
const ClearButton = styled.button`
  background-color: transparent;
  border: none;
  position: absolute;
  right: 10px;
  top: 15px;
  cursor: pointer;
`

const AutoSuggest = ({ itemToString, items, placeholder, onChange, itemSelected }) => {
  return (
    <Downshift
      itemToString={itemToString}
      selectedItem={itemSelected}
      onChange={onChange}
      render={({
        getInputProps,
        getItemProps,
        isOpen,
        inputValue,
        highlightedIndex,
        selectedItem,
        clearSelection
      }) => (
        <div>
          <Div>
            <Input {...getInputProps({ placeholder })} />
            {selectedItem.employeeId > 0 ? (
              <ClearButton onClick={clearSelection} aria-label="clear selection">
                <CloseIcon />
              </ClearButton>
            ) : null}
            {isOpen ? (
              <div>
                <Scrollbars autoHeight autoHeightMin={20}>
                  {matchSorter(items, inputValue, {
                    keys: ["name"],
                    threshold: matchSorter.rankings.WORD_STARTS_WITH
                  }).map((item, index) => (
                    <div
                      {...getItemProps({
                        key: item.employeeId,
                        index,
                        item
                      })}
                    >
                      <PersonCard item={item} highlightedItem={index === highlightedIndex} />
                    </div>
                  ))}
                </Scrollbars>
              </div>
            ) : null}
          </Div>
        </div>
      )}
    />
  )
}

AutoSuggest.propTypes = {
  itemToString: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape(PersonCardShape)),
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  itemSelected: PropTypes.shape(PersonCardShape).isRequired
}

AutoSuggest.defaultProps = {
  items: [],
  placeholder: ""
}
export default AutoSuggest



// WEBPACK FOOTER //
// ./src/components/inputs/AutoSuggest.jsx